var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchConditionTagsContainer',[(_vm.selectedTermType)?_c('TagTermType',{attrs:{"termBtnData":_vm.termTypeItems,"termType":_vm.selectedTermType,"loading":_vm.loading},on:{"updateTermType":_vm.changeTermType}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }